<!--
 * @Date: 2022-12-08 14:18:53
 * @LastEditTime: 2022-12-19 19:30:51
 * @Description: file content
-->
<template>
  <div id="preload-page">
    <div v-if="!isLoadingShow && !hasData" id="no-data-page">
      <div id="text-holder">
        <p>2020年 未用诊所答题</p>
        <p>2021年 邀您医路同行</p>
      </div>
    </div>
    <div id="opening">
      <div id="start-button">
        <img
          :class="{ btn: true, 'is-hide': isStarted }"
          src="https://resource.chunyu.mobi/@/media/images/2022/12/08/0b9e/0f0aa0e75c07_w724_h183_.png"
          @click="startVideo"
        />
        <img
          class="start-button-hand"
          src="https://resource.chunyu.mobi/@/media/images/2022/12/08/0f2c/da1b49840991_w238_h240_.png"
          alt=""
        />
        <p class="activity-rules" @click="$emit('jumpToRules')">活动规则</p>
      </div>
      <div id="video-holder">
        <img
          id="background"
          src="https://resource.chunyu.mobi/@/media/images/2022/12/08/177c/b1e410641a57_w1124_h2435_.png"
        />
        <img
          class="header"
          src="https://resource.chunyu.mobi/@/media/images/2022/12/08/4424/10e261ea3e5d_w988_h393_.png"
          alt=""
        />
        <div id="halo" :class="{ 'animated-halo': isStarted }" />
        <img
          src="https://resource.chunyu.mobi/@/media/images/2022/12/08/a69b/1b28389234a2_w1125_h2458_.png"
          alt=""
          class="road"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageMixin from '@/mixins/mixin.js';

export default {
  name: 'PreloadPage',
  components: {},
  mixins: [PageMixin],
  props: {
    platform: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isStarted: false,
      percentage: 0,
      isLoadingShow: true,
    };
  },
  computed: {
    hasData() {
      return true;
      // return Object.keys(this.detail).length > 0;
    },
  },
  mounted() {
    setTimeout(() => {
      this.isLoadingShow = false;
    }, 6000);
  },
  methods: {
    startVideo() {
      console.log(this.platform);
      if (this.platform === 'h5') {
        this.$emit('openUrlLink');
        return;
      }
      this.isStarted = true;
      setTimeout(() => {
        this.$emit('animate-end');
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
@function rem($px) {
  @return $px / 41.4 * 1rem;
}
$durationTime: 2.5s;

#preload-page {
  position: relative;
  z-index: 2;
  width: 100%;
  height: 100vh;
  overflow: hidden;

  #preload {
    #assets {
      position: absolute;
      width: 0;
      height: 0;
      overflow: hidden;
    }
  }

  #no-data-page {
    position: absolute;
    z-index: 5;
    width: 100%;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.6);

    #text-holder {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 100%;
      transform: translate(-50%, -50%);
      p {
        margin: 0;
        color: white;
        font-weight: bold;
        font-size: rem(22);
        line-height: rem(33);
        text-align: center;
      }
    }
  }

  #loading {
    position: relative;
    width: 100%;
    height: 100vh;
    &.hide {
      display: none;
    }

    #loading-content-holder {
      position: absolute;
      top: 50%;
      left: 50%;
      display: block;
      text-align: center;
      transform: translate(-50%, -50%);
    }
    p {
      position: relative;
      top: -10px;
      margin: 0;
      color: #666;
      font-size: rem(16);
      text-align: center;
    }
    img {
      width: 60%;
    }
  }

  #opening {
    position: relative;
    z-index: 2;
    width: 100%;
    height: 100vh;
    transform: scale(1);
    &.zoomin {
      transform: scale(4);
      animation-name: zoomin;
      animation-duration: $durationTime;
      animation-timing-function: ease-in-out;
      @keyframes zoomin {
        0% {
          transform: scale(1);
        }
        100% {
          transform: scale(4);
        }
      }
    }
    #video-holder {
      position: relative;

      #preload-video {
        z-index: 3;
        width: 100%;
        pointer-events: none;
      }
      #background {
        position: relative;
        z-index: 5;
        width: 100%;
      }
      .door {
        position: absolute;
        left: 50%;
        z-index: 4;
        width: 20%;
        margin-top: 55%;
        &#left {
          transform: translate(-100%, 0);
          &.animated-left {
            transform: translate(-200%, 0);
            animation-name: leftDoor;
            animation-duration: $durationTime;
            animation-timing-function: ease-in-out;
            animation-iteration-count: 1;
            @keyframes leftDoor {
              0% {
                transform: translate(-100%, 0);
              }
              100% {
                transform: translate(-200%, 0);
              }
            }
          }
        }
        &#right {
          transform: translate(0, 0);
          &.animated-right {
            transform: translate(100%, 0);
            animation-name: rightDoor;
            animation-duration: $durationTime;
            animation-timing-function: ease-in-out;
            animation-iteration-count: 1;
            @keyframes rightDoor {
              0% {
                transform: translate(0, 0);
              }
              100% {
                transform: translate(100%, 0);
              }
            }
          }
        }
      }
      #halo {
        position: absolute;
        top: 18%;
        left: 50%;
        z-index: 7;
        width: rem(300);
        height: rem(300);
        margin-top: 52%;
        background: radial-gradient(#fff, rgba(255, 255, 255, 0) 70%);
        border-radius: 50%;
        transform: translate(-50%, -50%);
        opacity: 0;
        &.animated-halo {
          z-index: 9;
          opacity: 1;
          animation-name: halo;
          animation-duration: 1s;
          animation-timing-function: linear;
          animation-iteration-count: 1;
          animation-fill-mode: forwards;
          @keyframes halo {
            0% {
              opacity: 0;
            }
            100% {
              width: 150vh;
              height: 150vh;
              background: radial-gradient(#fff, rgba(255, 255, 255, 0) 70%);
              opacity: 1;
            }
          }
        }
      }
    }

    #start-button {
      position: absolute;
      bottom: 10%;
      left: 50%;
      z-index: 8;
      display: block;

      // bottom: rem(40);
      // margin-top: 138%;
      transform: translate(-50%, 0);
      .btn {
        width: rem(266);
      }
      .start-button-hand {
        position: absolute;
        top: rem(21);
        right: rem(-39);
        width: rem(88);
        height: rem(88);
        transform: scale(4);
        animation-name: zoomin;
        animation-duration: 1s;
        animation-iteration-count: infinite;
        @keyframes zoomin {
          0% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.2);
          }
          100% {
            transform: scale(1);
          }
        }
      }
      &.is-hide {
        opacity: 0;
        transition: all 0.2s;
      }
      .activity-rules {
        position: relative;
        width: fit-content;
        margin: rem(23) auto 0;
        color: #fff;
        font-weight: 300;
        font-size: 16px;
        letter-spacing: rem(4);
        text-align: center;
        &::before {
          position: absolute;
          bottom: -1px;
          left: 0;
          width: 100%;
          height: rem(1);
          background: #fff;
          content: '';
        }
      }
    }
  }
  .header {
    position: absolute;
    top: 24px;
    left: 50%;
    z-index: 6;
    width: rem(364);
    height: rem(145);
    transform: translateX(-50%);
  }
  .road {
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 6;
    width: 100%;
  }
}
</style>
